goog.provide("shadow.js.shim.module$src$svg$location$map_marker_svg$default");
shadow.js.shim.module$src$svg$location$map_marker_svg$default = shadow.js.shim.module$src$svg$location$map_marker_svg.default;
